import React, { useState, useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next'; 

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { getRandomColor, calculateNextButtonLabel } from '../../utils/helpers';

import { useAppData } from "../../hooks/useAppData";
import { useAppStore } from "../../hooks/useAppStore";

import { useHover } from '../../contexts/HoverContext'; 
//import { useData } from '../../contexts/DataContext'; 
import { useNotification } from '../../contexts/NotificationContext'; 

import {
  TextField,
  IconButton,
  ClickAwayListener
} from "@mui/material";

import {
  Delete as DeleteIcon
} from "@mui/icons-material";

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

const WordListBoard = () => {
  const wordListBoardRef = useRef(null);

  const { t } = useTranslation(); 
  const { showNotification } = useNotification();

  const [addingState, setAddingState] = useState({ groupId: null, isAdding: false });
  const [currentInput, setCurrentInput] = useState("");
  const [addingGroup, setAddingGroup] = useState(false); // State to track if adding a new group

  const [editingGroupId, setEditingGroupId] = useState(null);
  const [tempTitle, setTempTitle] = useState("");

  //sconst [wordGroupId, setWordGroupId] = useState(null);
  const [editingWordId, setEditingWordId] = useState(null);
  const [tempWordText, setTempWordText] = useState("");
                                                    
  const [newGroupName, setNewGroupName] = useState(""); // State for the new group name input

  const [groupError, setGroupError] = useState({ text: "", groupId: null }); // State to track group errors
  const [newGroupError, setNewGroupError] = useState({ text: "", groupId: null }); // State to track group errors
  const [wordError, setWordError] = useState({ text: "", itemId: null }); // State to track word errors
  const [newWordError, setNewWordError] = useState({ text: "", itemId: null }); // State to track word errors
 
  const { 
    hoveredButtonId,
    handleHoverEnter, 
    handleHoverLeave,
    handleWordDragStart,
    handleWordDragEnd,
    stageRef,
    isDraggingWord,
    draggedWordId,
    draggedWordPosition,
    setDraggedWordPosition,
    setDraggedWordId
  } = useHover();

  /*const { 
    //wordList, 
    //wordListId, 
    //setWordList, 
    //getWordList, 
    //getSoundboard,
    //updateButton,
    //handleOptionChange,
    calculateNextButtonLabel,
    //getRandomColor,
    //colorOptions,
   // addWordItem,
    //updateWordList, 
    //updateWordListOnReorder,
    //addGroup,
    //deleteGroup, 
   // deleteWord, 
    //unassignButton,
   // setButtonPopovers,
    //shapes,
    //wordListWidth,
    //setWordListWidth
  } = useData();*/

  const { 
    wordList, 
    isWordListPending,
    isWordListError, 
    wordListRefetch,
    updateWordList,
    updateWordListOnReorder,
    addGroup,
    deleteGroup,
    addWordItem,
    deleteWord,
    soundboard,
    shapes,
    isSoundboardPending,
    isSoundboardError, 
    soundboardRefetch,
    addShape,
    updateShape,
    updateButton,
    unassignButton,
    deleteShape,
    handleOptionChange,
    handleAssignedWordTooltipVisibility,
    assignedWordTooltipVisibility
  } = useAppData();
    
  const { 
      baseURL,
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth,
      isPendingAssignWord, setIsPendingAssignWord,
      isPendingDeleteGroup, setIsPendingDeleteGroup,
      lastUsedShapeColor, setLastUsedShapeColor,
      lastUsedButtonColor, setLastUsedButtonColor
  } = useAppStore();

  // Function to handle the addition of a new group
  const handleAddGroup = () => {
    if (newGroupName.trim() === "") {
      setNewGroupName("");
      setAddingGroup(false);
      setGroupError({ text: "", itemId: null });
      return;
    }
  
    const validationError = validateGroupName(newGroupName, wordList);

    if (validationError.text) {
        setNewGroupError({text:validationError.text, groupId: null});
        return;
    }

    if (wordListId) {
      addGroup.mutate(newGroupName.trim());
      setNewGroupName("");
      setAddingGroup(false);
      setNewGroupError({text: "", groupId: null}); // Clear error after successful addition
    } else {
      setAddingGroup(false); // Switch back to the "+ Add Group" button if input is empty
    }
  }

  const onWordDragStart = (start) => {
    handleWordDragStart(start.draggableId); 
  };

  const onWordDragEnd = (result) => { 
    const { source, destination, draggableId } = result; //draggableId is the wordItem from react-beautiful-dnd

    const draggedWord = wordList
      .flatMap(group => group.wordItems)
      .find(wordItem => wordItem._id === draggableId);

    if (!draggedWord) {
      //console.error("Word not found for draggableId:", draggableId);
      return;
    }

    // Check if there is a hovered button when dragging ends
    const hoveredButton = shapes
    .flatMap(shape => shape.buttons)
    .find(button => button._id === hoveredButtonId); 

    if (hoveredButton) {
      // Assign the word to the hovered button
      const nextLabel = calculateNextButtonLabel(shapes);
      const newColor = getRandomColor();

      //handleOptionChange(hoveredButton._id, draggedWord); // Assign word to button
      handleOptionChange.mutate({ buttonId: hoveredButton._id, newValue: draggedWord, nextLabel, newColor });
      //return; // Stop further processing, as the word was dropped onto a button
    } 
    handleHoverLeave(); // Ensures the hover effect is removed
    handleWordDragEnd();

    if (!destination) return;

    // Ensure source and destination are valid before proceeding
    const sourceGroup = wordList.find(group => group._id === source.droppableId);
    const destinationGroup = wordList.find(group => group._id === destination.droppableId);


    if (!sourceGroup || !destinationGroup) {
      //console.error("Invalid source or destination group:", { source, destination });
      return;
    }

    // Update the state to reflect the changes
    updateWordListOnReorder.mutate({source, destination});


  };



  //find the parent shape that a button belongs in
  const findShapeByButtonId = (buttonId) => {
    return shapes.find(shape =>
      shape.buttons.some(button => button._id === buttonId)
    );
  };
  

  function findButtonById(buttonId) {  
 
    const shape = shapes.find(shape =>
      shape.buttons.some(button => button._id === buttonId)
    );
  
    const parentShape = findShapeByButtonId(buttonId);
    return parentShape?.buttons.find(button => button._id === buttonId);

  }


    const renderGroupTitle = (group) => {
      // Check if the current group is being edited
      if (editingGroupId === group._id) {
        return (
          <div>
            <TextField
              autoFocus
              //className="new-group-title-input"
              InputProps={{
                style: {
                  backgroundColor: 'white',
                  height: '45px', // Make the input height 100% of its parent
                  padding: 0, // Remove any padding that might affect height
                  boxSizing: 'border-box', // Ensure padding and border are included in the height calculation
                }
              }}
              type="text"
              value={tempTitle}
              onFocus={() => {
                if (group._id !== groupError.groupId){
                  setGroupError({text:"", groupId:null});
              }}}
              onChange={(e) => {
                const newValue = e.target.value;
                setTempTitle(newValue);

                const validationError = validateGroupName(newValue, wordList, group._id);
                setGroupError({text: validationError.text, groupId: group._id});
              }}
              onBlur={() => {
                updateGroupTitle(group._id);
                setGroupError({text:"", groupId:null});
              }}
              onKeyDown={(e) => {
                  if (e.key === "Enter" && !groupError.text) {
                      updateGroupTitle(group._id);
                  }
              }}
              error={Boolean(groupError.text)}
              helperText={groupError.text}
            />
            {/*groupError.text && <div className="input-error-message">{groupError.text}</div>*/}
          </div>
        );

      } else {
        return (
          <div
            className="word-group-name"
            onClick={() => {
              setEditingGroupId(group._id);
              setTempTitle(group.groupName);
            }}
          >
            {group.groupName}
            <DeleteIcon 
              className="delete-group-icon" 
              aria-label={t('wordList.delete')} 
              onClick={() => handleDeleteGroup(group._id, group.groupName)} 
            />
          </div>
        );
      }
    };
  
    const updateGroupTitle = (groupId) => {

      const validationError = validateGroupName(tempTitle, wordList, groupId);

      if (validationError.text) {
          setGroupError({text:validationError.text, groupId:groupId});
          setTempTitle(wordList.find(group => group._id === groupId).groupName);
          setEditingGroupId(null); // Exit edit mode
          return;
      }

      
      /*if (tempTitle.trim() === "") {
        setTempTitle(wordList.find(group => group._id === groupId).groupName);
        setEditingGroupId(null); // Exit edit mode
        return;
      }

      if (wordList.some(group => group._id !== groupId && group.groupName.toLowerCase() === tempTitle.trim().toLowerCase())) {
        setGroupError("Group name already exists");
        setTempTitle(wordList.find(group => group._id === groupId).groupName);
        setEditingGroupId(null); // Exit edit mode
        return;
      }*/
  
      wordList?.map((group) => {
          if (group._id === groupId) {
            return { ...group, groupName: tempTitle.trim() };
          }
          return group;
        });
        
        updateWordList.mutate({ wordGroupId: groupId, wordId: '', updates: [{field: 'groupName', newValue: tempTitle}] });
        setEditingGroupId(null); // Exit edit mode
        setGroupError({text:"", groupId: null}); // Clear error after successful update
      };
    

    const renderWord = (item, group) => {

      const handleClickAway = () => {
        // Close the edit mode if clicked away
        if (editingWordId === item._id) {
          updateWordText(group._id, item._id, tempWordText);
        }
      };

      if (editingWordId === item._id) {
        return (
          <ClickAwayListener onClickAway={handleClickAway}>

            <div className="edit-word-container"> 

              <TextField //CSS controlled in edit-word-container MUI-elements
                InputProps={{
                  style: {
                    fontSize: '14px', // Set font size to 10px
                    height: '45px',
                  }
                }}
                type="text"
                value={tempWordText}
                onFocus={() => {
                  if (item._id !== wordError.itemId){
                    setWordError({text:"", itemId:null});
                  }
                }}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setTempWordText(newValue);

                  const validationError = validateWordInput(newValue, wordList, item._id);
                  setWordError({text: validationError.text, itemId: item._id});
                }}
                onBlur={() => {
                  updateWordText(group._id, item._id, tempWordText);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !wordError.text) {
                    updateWordText(group._id, item._id, tempWordText);
                  }
                }}
                error={Boolean(wordError.text)}
                helperText={wordError.text}
                autoFocus
              />
              {/*wordError.text && <div className="input-error-message">{wordError.text}</div>*/}

            </div>
          </ClickAwayListener>

        );
      } else {
        return (
          <div
            className="word"
            onMouseEnter={() => handleMouseEnter(item.buttonId)}
            onMouseLeave={handleMouseLeave}
            //className={hoveredButtonId === item.buttonId && hoveredButtonId !== 0 ? "word" : "word"}
            onClick={() => {
              // If we're editing another word, first update and exit edit mode before switching to this one
              if (editingWordId) {
                updateWordText(group._id, editingWordId, tempWordText);
              };
              setEditingWordId(item._id);
              setTempWordText(item.text);
            }}
          >
            <button
              className="circle-button"
              style={{ backgroundColor: findButtonById(item.buttonId)?.color  || findShapeByButtonId(item.buttonId) || "" }}
            >
              {findButtonById(item.buttonId)?.buttonLabel}
            </button>

            <span className="word-text">
                {item.text}
            </span>

            <DeleteIcon 
              className="delete-icon" 
              aria-label={t('wordList.delete')} 
              onClick={() => handleDeleteWord(group._id, item._id, item.text)} 
            />
          </div>
        );
      }
    };

    const validateGroupName = (newValue, wordList, currentGroupId = null) => {
      if (newValue.trim() === "") {
        return { text: t('wordList.errors.groupEmpty'), groupId: currentGroupId };
      }
      if (wordList.some(group => group._id !== currentGroupId && group.groupName.toLowerCase() === newValue.trim().toLowerCase())) {
        return { text: t('wordList.errors.groupExists'), groupId: currentGroupId };
      }
      return { text: "", itemId: null };
  };

    const validateWordInput = (newValue, wordList, currentItemId = null) => {
      if (newValue.trim() === "") {
          return { text: t('wordList.errors.wordEmpty'), itemId: currentItemId };
      } else if (wordList.some(group => 
          group.wordItems.some(wordItem => 
              wordItem._id !== currentItemId && wordItem.text.toLowerCase() === newValue.trim().toLowerCase()
          )
      )) {
          return { text: t('wordList.errors.wordExists'), itemId: currentItemId };
      }
      return { text: "", itemId: null };
  };

    const updateWordText = (groupId, wordId, newText) => {
      // Find the original word text safely
      const group = wordList.find(group => group._id === groupId);
      const wordItem = group ? group.wordItems.find(wordItem => wordItem._id === wordId) : null;
      const originalWordText = wordItem ? wordItem.text : "";

      // If newText is undefined or null, handle it gracefully
      if (!newText || typeof newText !== 'string') {
        setEditingWordId(null); // Exit edit mode safely
        return;
      }

      // If the word inside didn't change, close the edit mode
      if (newText.trim() === originalWordText.trim()) {
        setEditingWordId(null); // Exit edit mode without updating
        return;
      }

      if (newText.trim() === "") {
        //if edited word to be empty, then keep original word
        setTempWordText(originalWordText);
        setEditingWordId(null); // Exit edit mode
        return;
      }

      if (wordList.some(group => 
        group.wordItems.some(wordItem => 
          wordItem._id !== wordId && wordItem.text.toLowerCase() === tempWordText.trim().toLowerCase()
      ))) {
        setWordError({text: t('wordList.errors.wordExists'), itemId:wordId});
        return;
      }
    

      // Optimistically update the word list
      const updatedWordList = wordList?.map(group => {
        if (group._id === groupId) {
          return {
            ...group,
            wordItems: group.wordItems.map(wordItem =>
              wordItem._id === wordId ? { ...wordItem, text: newText.trim() } : wordItem
            )
          };
        }
        return group;
      });

      // Set the optimistic update
      //setWordList(updatedWordList);

      updateWordList.mutate({ wordGroupId: groupId, wordId, updates: [{field: 'text', newValue: tempWordText.trim()}] });

      // Clear edit mode and error state after updating
      setEditingWordId(null);
      setTempWordText("");
      setWordError({text:"", itemId:null}); // Clear error after successful update
    };

    const handleAddWord = () => {

        if (currentInput.trim() === "") {
          setCurrentInput("");
          setAddingState({ groupId: null, isAdding: false });
          setNewWordError({ text: "", itemId: null });
          return;
        }

      const validationError = validateWordInput(currentInput, wordList);
      if (validationError.text) {
          setNewWordError({text: validationError.text, itemId: null});
          return;
      }

      if (addingState.groupId) {
        addWordToList(currentInput.trim(), addingState.groupId);
        setCurrentInput("");
        setAddingState({ groupId: null, isAdding: false });
        setNewWordError({text:"", itemId:null}); // Clear error after successful addition
      }  

    };
  
    const addWordToList = (word, groupId) => {
      const newGroups = wordList?.map(group => ({
        ...group,
        wordItems: [...group.wordItems]  // Making a deep copy of the items array
      }));
      const newWord = { 
        text: word, 
        buttonId: 0 
      }; // Default buttonId is 0

      // Find the index of the group where the new word should be added
      const groupIndex = newGroups.findIndex(group => group._id === groupId);

      // Check if the group was found
      if (groupIndex !== -1) {
        newGroups[groupIndex].wordItems.push(newWord);
      }

      addWordItem.mutate({ wordGroupId: groupId, newWord: word });
    };

    const handleDeleteWord = async (groupId, wordId, text) => {
      if (window.confirm(t('wordList.deleteWordConfirmation', { text }))) {
        const group = wordList.find(group => group._id === groupId);
        const wordToDelete = group?.wordItems?.find(wordItem => wordItem._id === wordId);
    
        // Ensure buttonId is valid (not null, undefined, or 0)
        if (wordToDelete?.buttonId && wordToDelete.buttonId !== "0" && wordToDelete.buttonId !== 0) {    
          // Find the shape containing the button
          const shape = shapes.find(shape =>
            shape.buttons.some(button => button._id === wordToDelete.buttonId)
          );
    
          if (shape) {
    
            // Ensure button exists in the shape before updating state
            const buttonExists = shape.buttons.some(button => button._id === wordToDelete.buttonId);
    
            if (buttonExists) {
              setButtonPopovers(prev => ({
                ...prev,
                [wordToDelete.buttonId]: {
                  ...prev[wordToDelete.buttonId],
                  selectedOption: null,
                  inputValue: ''
                }
              }));
            }
          } else {
            showNotification({
              notification: t('errors.snackbar.ShapeNotFoundForButton'),
              type: 'error',
              extra: { 
                shape,
                shapeId: shape ? shape._id : 'N/A',
                wordToDelete, 
              },
              isException: false,
            });
          }
        } 
    
        deleteWord.mutate({ wordGroupId: groupId, wordId });
      }
    };

    const handleDeleteGroup = async (groupId, groupName) => {
      if (window.confirm(t('wordList.deleteGroupConfirmation', { groupName }))) {
        setIsPendingDeleteGroup(true);
        try {
          await deleteGroup.mutateAsync(groupId);
        } catch (err) {
          console.error('Failed to delete group:', err);
        } finally {
          setIsPendingDeleteGroup(false);
        }
      }
    };

    const handleMouseEnter = (buttonId) => {
      handleHoverEnter(buttonId); 
    };

    const handleMouseLeave = () => {
      handleHoverLeave();
    };

    //wordList column width to calculate position of where new panels are placed
    useEffect(() => {
      if (wordListBoardRef.current) {
        setWordListWidth(wordListBoardRef.current.getBoundingClientRect().width);
      }
    }, []);

    useEffect(() => { // Sets dragged word position to be used on PetButton mobile to detect if a word is over a petbutton
      const handleGlobalPointerMove = (e) => {
          if (!isDraggingWord) return;
  
          // Get the pointer position relative to the viewport
          const { clientX, clientY } = e;
  
          // Convert to Konva coordinates
          const stage = stageRef.current;
          if (!stage) return;
  
          const stageBox = stage.container().getBoundingClientRect();
          const stagePos = stage.position(); // The current pan offset
          const scale = stage.scaleX(); // Assume uniform scale for X and Y

          const konvaX = (clientX - stageBox.left - stagePos.x)/scale;
          const konvaY = (clientY - stageBox.top - stagePos.y)/scale;

          // Update dragged position
          setDraggedWordPosition({ x: konvaX, y: konvaY });
      };
  
      // Attach global event listener
      window.addEventListener('pointermove', handleGlobalPointerMove);
  
      return () => {
          // Cleanup listener when drag ends
          window.removeEventListener('pointermove', handleGlobalPointerMove);
      };
    }, [isDraggingWord]); // Run effect when dragging starts



  return (
    <DragDropContext
      onDragStart={onWordDragStart}
      onDragEnd={onWordDragEnd}     
      enableDefaultSensors={true}
    >
      {/*<div className="wordList-filter">filter placeholder</div>*/}
      <div className="board" ref={wordListBoardRef}>
        {/* Button to add a new group */}
          {!addingGroup ? (
            <div className={'add-word-group'}>
              
              <IconButton 
                aria-controls="add-group"
                aria-haspopup="true"
                variant="wordlist"
                onClick={() => setAddingGroup(true)} 
                aria-label={t('wordList.addGroupLabel')}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 'var(--font-size-base)', // Decrease font size of the button text
                  '& .MuiSvgIcon-root': {
                    marginRight: '8px', // Add padding between the icon and text
                  },
                  '&:hover': {
                    backgroundColor: 'var(--wordlist-panel-color)', // Keep the same color on hover
                    transform: 'scale(1.05)', // Optional: Add a slight scale effect on hover
                  },
                }}
              >
                  <AddCircleOutlineRoundedIcon />
                  <span className="add-new-btn">{t('wordList.addGroupLabel')}</span>
                </IconButton>
            </div>
          ) : (
            <div className={'add-word-group'}>
              <div style={{ width: '100%' }}>

                <TextField
                  type="text"
                  //className="new-group-title-input"
                  InputProps={{
                    style: {
                      backgroundColor: 'white',
                      fontSize: '14px', // Set font size to 10px
                      height: '40px', // Make the input height 100% of its parent
                      padding: '0', // Remove any padding that might affect height
                      margin: '0',
                      boxSizing: 'border-box', // Ensure padding and border are included in the height calculation
                    }
                  }}
                  value={newGroupName}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setNewGroupName(newValue);

                    const validationError = validateGroupName(newValue, wordList);
                    setNewGroupError({text: validationError.text, groupId:null});
                  }}
                  onBlur={()=> {
                    handleAddGroup();
                    setNewGroupName("");
                    setAddingGroup(false);
                    setNewGroupError({text:"", groupId:null});
                }} // Trigger when input loses focus
                  onKeyPress={(e) => {
                      if (e.key === "Enter" && !newGroupError.text) {
                          handleAddGroup();
                      }
                  }}
                  error={Boolean(newGroupError.text)}
                  helperText={newGroupError.text}
                  placeholder={t('wordList.enterNewGroup')}
                  autoFocus
                />
                {/*newGroupError.text && <div className="input-error-message">{newGroupError.text}</div>*/}
              </div>
            </div>
          )}

{wordList && wordList.length > 0 ? (
          wordList.map(group => (
            <Droppable key={group._id} droppableId={group._id}>
              {(provided) => (
                <div className="word-group" ref={provided.innerRef} {...provided.droppableProps}>
                  {renderGroupTitle(group)}

                  {group.wordItems.map((wordItem, index) => (
                    <Draggable key={wordItem._id} draggableId={wordItem._id} index={index}>
                      {(provided, snapshot) => (
                        <div 
                          className="word-container" 
                          ref={provided.innerRef} 
                          {...provided.draggableProps} 
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.5 : 1, // 50% opacity while dragging. isDragging is built into react-beautiful-dnd, it's about dragging a word item
                          }}
                        >
                            {renderWord(wordItem, group)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                  {/* Input Box or Add New Word Button */}
                  {addingState.isAdding && addingState.groupId === group._id ? (
                    <div>
                      <TextField
                        type="text"
                        InputProps={{
                          style: {
                            backgroundColor: 'white',
                            height: '45px', // Make the input height 100% of its parent
                            padding: 0, // Remove any padding that might affect height
                            boxSizing: 'border-box', // Ensure padding and border are included in the height calculation
                          }
                        }}
                        value={currentInput}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setCurrentInput(newValue);
          
                          const validationError = validateWordInput(newValue, wordList);
                          setNewWordError({text: validationError.text, itemId: null});
                        }}
                        onFocus={() => {
                            setWordError({text:"", itemId:null});
                        }}
                        onBlur={() => {
                            handleAddWord();
                            setCurrentInput("");
                            setAddingState({ groupId: null, isAdding: false });
                            setNewWordError({text:"", itemId: null});
                        }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter" && !wordError.text) {
                            handleAddWord ();
                          }
                        }}
                        error={Boolean(newWordError.text)}
                        helperText={newWordError.text}
                        placeholder={t('wordList.enterNewWord')}
                        autoFocus
                      /> 
                      {/*addingState.isAdding && addingState.groupId === group._id && newWordError.text && <div className="input-error-message">{newWordError.text}</div>*/}
                    </div>
                          ) : (
                            <IconButton 
                            aria-controls="add-group"
                            aria-haspopup="true"
                            variant="wordlist"
                            onClick={() => {
                              setAddingState({ groupId: group._id, isAdding: true });
                              setEditingWordId(null);
                            }}
                            aria-label={t('wordList.addWordLabel')}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: 'var(--font-size-base)', // Decrease font size of the button text
                              '& .MuiSvgIcon-root': {
                                marginRight: '8px', // Add padding between the icon and text
                              },
                              '&:hover': {
                                backgroundColor: 'var(--wordlist-panel-color)', // Keep the same color on hover
                                transform: 'scale(1.05)', // Optional: Add a slight scale effect on hover
                              },
                            }}
                          >
                              <AddCircleOutlineRoundedIcon />
                              <span className="add-new-btn">{t('wordList.addWordLabel')}</span>
                            </IconButton>
                          )}
                </div>
              )}
            </Droppable>
            
          ))
          
        ) : (
          <p className="noWords">No words</p>
        )}
      </div>
    <div className="wordlist-gradient"></div>

    </DragDropContext>
  );
};


WordListBoard.defaultProps = {
    groups: []
};

export default WordListBoard;
